import Api from '@common/services/api';
import { CompetancyPayload } from '../types';

export const createCompetancy = async (organisationId: string, payload: CompetancyPayload) => {
  const { data } = await Api.post(
    `/v1/organisations/${organisationId}/performance/competencies`,
    payload
  );

  return { data };
};

